import React from 'react'
import PropTypes from 'prop-types'
import { useEffect } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { isNotEmpty } from 'common/helpers'
import actions from 'redux/actions'

import Title from 'components/_new/typography/deprecated/Title/Title'
import Grid from 'components/_new/layout/grid/Grid/Grid'
import Text from 'components/_new/typography/Text/Text'
import Card from 'components/_new/layout/Card/Card'
import Button from 'components/_new/Button/Button'
import Box from 'components/_new/layout/Box/Box'

import ContentLoader from 'components/loaders/ContentLoader/ContentLoader'

import Order from './Order/Order'

import messages from './messages'


const BillingReview = ({ onClick }) => {
  const { orders } = useConnect({
    orders: 'view.shippingAndBillingIssuesModal.orders',
  })

  useEffect(() => {
    actions.view.shippingAndBillingIssuesModal.fetchOrders()
  }, [])

  return (
    <Box alignLeft mt="36">
      <Title message={messages.title} size="sm" />
      <Grid columns={{ mobile: 1, exceptMobile: 2 }} gutter="16">
        {
          isNotEmpty(orders) ? (
            orders.map((item) => (
              <Order
                key={`${item.year}-${item.month}`}
                {...item}
              />
            ))
          ) : (
            <ContentLoader />
          )
        }
      </Grid>
      <Box mt="8">
        <Grid columns={{ mobile: 1, exceptMobile: 2 }} gutter="16">
          <Card size="md" withBg>
            <Text message={messages.billingProblem} html />
            <Box alignCenter mt="24">
              <Button
                size="sm"
                color="brandTransparent"
                fullWidth
                title={messages.report}
                onClick={onClick}
              />
            </Box>
          </Card>
        </Grid>
      </Box>
    </Box>
  )
}

BillingReview.propTypes = {
  onClick: PropTypes.func.isRequired,
}


export default BillingReview
